import ExpensesSummaryBoxFilter from './expensesSummaryBoxFilter/expensesSummaryBoxFilter';

require('./expensesSummaryBox.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const classnames = require('classnames');
const { connect } = require('react-redux');

// @actions
const { requestCategoriesSummary } = require('actions/expensesByCategories/ExpensesByCategoriesSummaryBox');

// @utilities
const moment = require('moment');
const { FormattedText } = require('core/i18n').i18n;

// @commons
const { OKLink } = require('commonsComponents/OKLink');
const { OKLoadingErrorMessage } = require("commonsComponents/OKLoadingErrorMessage");

// @constants
const {
    DATE_FORMAT_API,
 } = require('constants/index');
const {
    EURO_TEXT
} = require('constants/index');
const { ALL_MOVEMENTS, DEBIT_MOVEMENTS, CREDIT_MOVEMENTS, CONTRACT_TYPE, CUSTOM_ACCOUNTS, LAST_MONTH_COMPARISON } = require('constants/expensesByCategories/filters');

// @components
const ExpensesSummaryBoxList = require('./expensesSummaryBoxList/expensesSummaryBoxList');
const ExpensesSummaryBoxHeader = require('./expensesSummaryBoxHeader/expensesSummaryBoxHeader');


class ExpensesSummaryBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isFilterOpen: false,
            filters:{
                [CONTRACT_TYPE]: ALL_MOVEMENTS,
                [LAST_MONTH_COMPARISON]: false,
                [CUSTOM_ACCOUNTS]: !!props.immFilter ? props.immFilter.getIn([CUSTOM_ACCOUNTS, 'active']) : true,
            },
        };
    }

    componentDidMount() {
        const {filters} = this.state;
        
        this.props.requestCategoriesSummary(filters[LAST_MONTH_COMPARISON], filters[CUSTOM_ACCOUNTS]);
    }

    componentDidUpdate(prevProps, prevState) {
        const {filters} = this.state;

        if(this.props.immFilter && this.props.immFilter.getIn(['lastMonthComparison']) && this.props.immFilter.getIn(['lastMonthComparison', 'active'])) {
            const prevmonth = this.props.immFilter ? this.props.immFilter.toJS().lastMonthComparison.active : false;
            if(filters[LAST_MONTH_COMPARISON] !== prevmonth) {
                this.setState({
                    filters: {
                        [CONTRACT_TYPE]: this.state.filters[CONTRACT_TYPE],
                        [LAST_MONTH_COMPARISON]: prevmonth,
                        [CUSTOM_ACCOUNTS]: this.state.filters[CUSTOM_ACCOUNTS],
                    }
                })
            }
        }

        if (prevState.filters[LAST_MONTH_COMPARISON] !== filters[LAST_MONTH_COMPARISON] || prevState.filters[CUSTOM_ACCOUNTS] !== filters[CUSTOM_ACCOUNTS]) this.props.requestCategoriesSummary(filters[LAST_MONTH_COMPARISON], filters[CUSTOM_ACCOUNTS]);
    }

    filterData = () => {
        const {filters} = this.state;
        return this.props.categoriesSummary.filter(data => {
            if (filters[CONTRACT_TYPE] === DEBIT_MOVEMENTS) {
                return data.get('tipoCuenta') === 0;
            } else if (filters[CONTRACT_TYPE] === CREDIT_MOVEMENTS) {
                return data.get('tipoCuenta') === 1;
            }else {
                return true;
            }
        });
    };
    
    separatePrevFromCurrentMonth = (filteredData) => {
        let prevMonth = [];
        let currentMonth = [];
        filteredData.map((item)=> { 
            if (moment(item.get('fecha').slice(0, 10)).isBefore(moment().startOf('month').format(DATE_FORMAT_API))) {
                prevMonth.push(item);
            } else {
                currentMonth.push(item);
            }
        });
        return {currentMonth: currentMonth, prevMonth: prevMonth};
    };
    
    buildValues = (data) => {
        const values = data.reduce((acc, item)=> {
            if (item.get('monto') < 0 && item.get('categoryCode') !== 7) {
                const index = acc.findIndex(cat => item.get('categoryCode') === cat[0]);
                index === -1? acc = [...acc,[item.get('categoryCode'), Math.abs(item.get('monto'))]] : acc[index] = [item.get('categoryCode'), Math.abs(item.get('monto')) + acc[index][1]];
            }
            return acc;
        },[]);

        return values.sort((a,b)=> b[1] - a[1]);
    };
    
    handleClickOnFilter = () => this.setState({ isFilterOpen: true });
    handleFilterClose = () => this.setState({ isFilterOpen: false });
    handleFilterSubmit = (evt, filters) => {
        evt.preventDefault();
        evt.stopPropagation();
        const newFilters = filters.map(filter => filter.get('filterType') === 'checkFilter' ? filter.get('active') : filter.get('selected')).toJS();
        this.setState(prevState => ({ 
            isFilterOpen: false,
            filters: { 
                ...prevState.filters,
                ...newFilters
            },
        }));
    };

    buildFooter = () => {
        return(
            <div className="expenses-summary-box__footer">
                <OKLink to="/myprofile/global/expenses-by-category/" modifier="widget">
                    <FormattedText
                        value={'globalPositionExpenses-showMore'}
                        className="expenses-summary-box__footer--text"
                    />
                </OKLink>
            </div>
        );
    };

    buildContent= () => {
        const {filters} = this.state;
        const currency = EURO_TEXT;
        const filteredData = this.filterData();
        const values = this.separatePrevFromCurrentMonth(filteredData);
        const currentValues = this.buildValues(values.currentMonth);
        const prevValues = filters[LAST_MONTH_COMPARISON] && this.buildValues(values.prevMonth);
        const currentTotal = currentValues.reduce((acc, value) => acc + value[1], 0);
        const prevTotal = filters[LAST_MONTH_COMPARISON] && prevValues.reduce((acc, value) => acc + value[1], 0);
        const isFiltersApplied = filters[CONTRACT_TYPE] !== ALL_MOVEMENTS || !filters[CUSTOM_ACCOUNTS];
        const footer = currentValues.length <= 0 || this.buildFooter();

        return ( 
            <React.Fragment>
                <ExpensesSummaryBoxHeader
                    currency={currency} 
                    currentTotal={currentTotal} 
                    prevTotal={prevTotal}
                    onFilterClick={this.handleClickOnFilter}/>
                <ExpensesSummaryBoxList 
                    currentValues={currentValues} 
                    prevValues={prevValues}
                    isFiltersApplied={isFiltersApplied}
                    currency={currency}/>
                {footer}
            </React.Fragment> 
        );
    };

    render() {
        const {isFetching, error} = this.props;
        const {isFilterOpen} = this.state;
        const content = isFilterOpen ? <ExpensesSummaryBoxFilter onCloseClick={this.handleFilterClose} onSubmit={this.handleFilterSubmit}/> : this.buildContent();
        const expensesClasses = classnames('container-fluid expenses-summary-box', {
            'expenses-summary-box--loading': isFetching
        });
        const style = isFetching || error ? {padding: "20px 0 10px"} : {};

        return (
            <div className={expensesClasses} style={style}> 
                <OKLoadingErrorMessage isLoading={isFetching} isError={error}> 
                    {content}
                </OKLoadingErrorMessage>
            </div>

        );
    }
}

ExpensesSummaryBox.propTypes = {
    categoriesSummary: PropTypes.array,
    error: PropTypes.bool,
    immAccounts: PropTypes.object,
    isFetching: PropTypes.bool,
    requestCategoriesSummary: PropTypes.func,
    immFilter: PropTypes.object,
};

module.exports.constructor = ExpensesSummaryBox;
export default connect(
    state => ({
        categoriesSummary: state.expensesByCategoriesSummaryBox.get('categoriesSummaryBox'),
        isFetching: state.expensesByCategoriesSummaryBox.get('fetching'),
        error: state.expensesByCategoriesSummaryBox.get('error'),
        immFilter: state.filters.get('pfm'),
        state: state,
    })
    ,
    {
        requestCategoriesSummary
    }
)(ExpensesSummaryBox);